import { Spinner } from "@timeghost/ui/shadcn/spinner";
import { cn } from "@timeghost/ui/utils";

export default function SpinnerPage({ className }: { className?: string }) {
	return (
		<div className={cn("z-99 flex h-screen flex-col items-center justify-center bg-background", className)}>
			<div className="flex flex-col items-center justify-center gap-4">
				<h1 className="font-bold text-2xl">timeghost</h1>
				<div className="flex items-center gap-2">
					<Spinner className="text-muted-foreground" size="sm" />
				</div>
			</div>
		</div>
	);
}
